import React, { useState, useEffect } from 'react';
import Select from 'react-select'; // Import react-select for multi-select dropdown
import AdminServices from '../../../services/AdminServices';
import LocationServices from '../../../services/LocationServices';
import { Modal, Button, Container, Row, Col } from 'react-bootstrap';
import Swal from "sweetalert2";



const UseEditModal = ({ show, handleClose, test, admin }) => {
  const [storeData, setStoreData] = useState([]);
  const isAccounts = (() => {
    try {
      const loggedInUser = JSON.parse(
        localStorage.getItem("userDetails") || "null"
      );

      return (
        String(loggedInUser?.data?.user?.role || "")
          .trim()
          .toLowerCase() === "accounts"
      );
    } catch {
      return false;
    }
  })();
  const [formValues, setFormValues] = useState({
    name: '',
    role: '',
    email: '',
    mobileNo: '',
    store: []
  });



  //const { data: storeData, error: storeError } = useAsync(LocationServices.getStore); // Fetch available stores

  useEffect(() => {
    if (admin) {
      const selectedStores = admin?.store?.map(store => ({
        value: store._id,
        label: `${store.name} (${store.location})`
      })) || [];

      setFormValues({
        name: admin?.name,
        role: admin?.role,
        email: admin?.email,
        mobileNo: admin?.mobileNo,
        store: selectedStores
      });
    }
  }, [admin]);

  // Fetch available stores using .then() and .catch() inside useEffect
  useEffect(() => {
    LocationServices.getStore()
      .then((response) => {
        setStoreData(response?.data?.data || []); // Set store data if the response is successful
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Validation Error",
          text: "Failed to fetch stores. Please try again later."
        });
        console.error("Error fetching stores:", error);
      });
  }, []);

  // Prepare store options for the multi-select dropdown
  const storeOptions = storeData?.map(store => ({
    value: store._id,
    label: `${store.name} (${store.location})`
  })) || [];

  // Handle form input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === "role" && value === "MachineOperator") {
      setFormValues((prev) => ({
        ...prev,
        role: value,
        store: prev.store.slice(0, 1), // Keep only first selected store
      }));
      return;
    }
    setFormValues({
      ...formValues,
      [name]: value
    });
  };
  // Handle store selection (multi-select)
  const handleStoreChange = (selectedOptions) => {
    const selectedStores = selectedOptions || [];

    if (
      formValues.role === "MachineOperator" &&
      selectedStores.length > 1
    ) {
      Swal.fire({
        icon: "warning",
        title: "Only One Store Allowed",
        text: "Only one store is allowed for Machine Operator role. Please remove the old store before adding a new one."
      });

      return;
    }

    setFormValues({
      ...formValues,
      store: selectedStores
    });
  };

  const isValidMobile = (mobile) => {
    const regex = /^[6-9]\d{9}$/;
    return regex.test(mobile);
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    // ✅ Validate mobile number
    if (!isValidMobile(formValues.mobileNo)) {
      Swal.fire({
        icon: "error",
        title: "Invalid Mobile Number",
        text: "Please enter a valid 10-digit mobile number starting with 6-9.",
      });

      if (
        formValues.role === "MachineOperator" &&
        formValues.store.length > 1
      ) {
        return Swal.fire({
          icon: "error",
          title: "Validation Error",
          text: "Only one store is allowed for Machine Operator role."
        });
      }
      return;
    }
    try {
      const updatedStores = formValues.store.map(store => ({ _id: store.value })); // Map selected stores to required format
      const updatedValues = { ...formValues, store: updatedStores };

      const response = await AdminServices.updateUser(admin._id, updatedValues);
      if (response.status === "success") {
        Swal.fire({
          icon: "success",
          title: "Good job!",
          text: "Deatils Has Been Successfully Updated!",
        });
        test(prev => prev + 1)
        //alert('Admin details updated successfully');
        handleClose();
      }
    } catch (error) {
      console.error('Failed to update admin details', error);
      alert('Failed to update admin details');
    }
  };


  return (
    <Modal className="fade" show={show} onHide={handleClose}>
      <form onSubmit={handleSubmit}>
        <Modal.Header>
          <Modal.Title><i class="fas fa-edit"></i> Edit Users Deatils!!!</Modal.Title>
          <Button variant="" className="btn-close" onClick={handleClose}></Button>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col md="6">
                <label>Role</label>
                <select
                  className="form-control"
                  value={formValues.role}
                  onChange={handleInputChange}
                  name="role"
                >
                  <option value="">--Select Role--</option>

                  {isAccounts ? (
                    <>
                      <option value="CashMaker">Cash Maker</option>
                      <option value="CashChecker">Cash Checker</option>
                    </>
                  ) : (
                    <>
                      <option value="admin">Admin</option>
                      <option value="storeKeeper">Store Keeper</option>
                      <option value="MachineOperator">Machine Operator</option>
                      <option value="pomaker">PO Maker</option>
                      <option value="pochecker">PO Checker</option>
                      <option value="billing">Billing</option>
                      <option value="accounts">Accounts</option>
                    </>
                  )}
                </select>
              </Col>
              <Col md="6">
                <label>Add/Remove Store</label>
                <Select
                  isMulti
                  value={formValues.store}
                  onChange={handleStoreChange}
                  options={storeOptions}
                  placeholder="Select stores..."
                  className="basic-multi-select"
                  classNamePrefix="select"
                />
              </Col>
              <Col md='12' className='mt-2 mb-2'>
                <label>Mobile Number</label>
                <input
                  type="number"
                  className="form-control"
                  name="mobileNo"
                  value={formValues.mobileNo}
                  onChange={handleInputChange}
                  maxLength={10}
                  placeholder="Enter 10-digit mobile number"

                />
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" type='submit'>Save changes</Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default UseEditModal;
